/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://47qxkblcs3.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        },
        {
            "name": "inspirusapi",
            "endpoint": "https://6yd4jgx76i.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:85fc8e30-319b-440c-b3d5-9a9904a66ad1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_sHZPDPjld",
    "aws_user_pools_web_client_id": "177ud8t96cpr9fqu900v876k2i",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "constituentReadiness-production",
            "region": "us-east-1"
        },
        {
            "tableName": "globalSettings-production",
            "region": "us-east-1"
        },
        {
            "tableName": "inspirus-production",
            "region": "us-east-1"
        },
        {
            "tableName": "organisationAppClients-production",
            "region": "us-east-1"
        },
        {
            "tableName": "organisationConstituents-production",
            "region": "us-east-1"
        },
        {
            "tableName": "prospectFunnelEvents-production",
            "region": "us-east-1"
        },
        {
            "tableName": "schoolDirectory-production",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "inspirus62c5f4e4cb59484e81f19c381330ceb25999c-production",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "search_indices": {
                "items": [
                    "locationSearch-production"
                ],
                "default": "locationSearch-production"
            }
        }
    }
};


export default awsmobile;
